// extracted by mini-css-extract-plugin
module.exports = {"credits":"Credits_credits__3gvRj","creditList":"Credits_creditList__3RCEZ","audioSection":"Credits_audioSection__18QPp"};